// extracted by mini-css-extract-plugin
export default {"main_div":"FormModal_main_div__tj4fF","error_msg":"FormModal_error_msg__q1Q7Z"};